import { BillingContext } from "../../Models/Billing/BillingContext";

const defaultState: BillingContext = {
  accountId: "",
  isGuestUser: "",
  portalCD: "",
  isPremiumUser: false,
  isMigratedUser: false,
  paymentPortal: "",
  skuSubCategory: "",
  currencyCD: "",
  skuGuid: "",
  upgradedAmount: "",
  upgradeSkuSubCategory: "",
  upgradeSkuGuid: "",
  currentPlanUser: 0,
  isValidEmail: true,
  cancelledDate: "",
  nextBillingDate: "",
  loggedInUserCurrency: "",
  customerId: "",
  cancelledAt: "",
  statusInChargebee: "",
  subscriptionId: "",
  isScheduleCancel: false,
  paymentSuccessPopup: "",
  paymentMethod: "",
  orderId: "",
  recurringPrice: 0.0,
  unitPrice: 0.0,
  skulabel: "",
  currencySymbol: "",
  scheduleTypeCD: "",
};

export default defaultState;
